import { render, staticRenderFns } from "./_transfers.vue?vue&type=template&id=6319ab26&scoped=true&"
import script from "./_transfers.vue?vue&type=script&lang=js&"
export * from "./_transfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6319ab26",
  null
  
)

export default component.exports